import Layout from './components/layout';
import TemplateLayout from '../template/components/layout';

export default {
	Layout,
	TemplateLayout
}